import "../css/CommonDesign.css";
import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import {
  Stepper, Step, StepLabel, TextField, Container, Stack, Radio, RadioGroup, FormControlLabel, FormLabel, Divider, Button, Select, MenuItem,
  FormHelperText, InputLabel, FormControl, Checkbox, FormGroup, Link, Breadcrumbs, Typography
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import axios from "axios";
import MenuMenu from "./MenuMenu";

const steps = [
  '情報入力',
  '内容の確認',
  '完了',
];

const D0041ContactTop = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [productName, setProductName] = useState(""); // 輸出品目名
  const [countryName, setCountryName] = useState(""); // 輸出先国名
  const [contactDetail, setContactDetail] = useState(""); // お問い合わせ内容
  const [companyName, setCompanyName] = useState(""); // 企業名
  const [corpoNum, setCorpoNum] = useState(""); // 法人番号
  const [director, setDirector] = useState(""); // 役職
  const [nameKanji, setNameKanji] = useState(""); // 氏名
  const [nameKana, setNameKana] = useState(""); // 氏名かな
  const [mailAddress, setMailAddress] = useState(""); // メールアドレス
  const [phoneNumber, setPhoneNumber] = useState(""); // 電話番号
  const [noShare, setNoShare] = useState(false); // 共有を承諾しない
  const [isConsent, setIsConsent] = useState(false); // 個人情報の取り扱いについて

  // const [address1, setAddress1] = useState(""); // 郵便番号
  // const [address2, setAddress2] = useState(""); // 都道府県
  // const [address3, setAddress3] = useState(""); // 市区町村名　番地・ビル名
  // const [sex, setSex] = useState(""); // 性別
  // const [age, setAge] = useState(''); // 年代

  // 必須チェックメッセージ
  const [errorContactDetail, setErrorContactDetail] = useState("お問い合わせ内容を入力してください。");
  const [errorNameKanji, setErrorNameKanji] = useState("例）農林　太郎"); // 必須チェック用メッセージ(氏名)
  const [errorNameKana, setErrorNameKana] = useState("例）のうりん　たろう"); // 必須チェック用メッセージ(氏名かな)
  const [errorMailAddress, setErrorMailaddress] = useState("例）nourin@example.co.jp"); // 必須チェック用メッセージ(メールアドレス)
  const [errorIsConsent, setErrorIsConsent] = useState(""); // 必須チェック用メッセージ(個人情報の取り扱いについて)
  // const [errorAddress1, setErrorAddress1] = useState("ハイフン不要"); // 入力チェック用メッセージ(郵便番号)

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    // 確認画面　戻る押下時、前画面からの情報で表示を復元する
    if (location.state != null) {
      const contacts = location.state.dataList;

      setProductName(contacts.productName);
      setCountryName(contacts.countryName);
      setContactDetail(contacts.contactDetail);
      setCompanyName(contacts.companyName);
      setCorpoNum(contacts.corpoNum);
      setDirector(contacts.director);
      setNameKanji(contacts.nameKanji);
      setNameKana(contacts.nameKana);
      setMailAddress(contacts.mailAddress);
      setPhoneNumber(contacts.phoneNumber);
      setNoShare(contacts.noShare);
      setIsConsent(contacts.isConsent);
    }

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;
  }, [])

  // 入力内容確認ボタン処理
  async function ContactCheck() {
    try {
      var errorcnt = 0;
      // const contactList = [];
      if (!nameKanji) {
        setErrorNameKanji("氏名（漢字）を入力してください。");
        errorcnt = errorcnt + 1;
      } else {
        setErrorNameKanji("例）農林　太郎");
      }

      if (!nameKana) {
        setErrorNameKana("氏名（かな）を入力してください。");
        errorcnt = errorcnt + 1;
      } else {
        setErrorNameKana("例）のうりん　たろう");
      }

      if (!mailAddress) {
        setErrorMailaddress("メールアドレスを入力してください。");
        errorcnt = errorcnt + 1;
      } else {
        setErrorMailaddress("例）nourin@example.co.jp");
      }

      if (!contactDetail) {
        setErrorContactDetail("相談内容を入力してください。");
        errorcnt = errorcnt + 1;
      } else {
        setErrorContactDetail("お問い合わせ内容を入力してください。");
      }

      if (isConsent == false) {
        setErrorIsConsent("プライバシーポリシーに同意が必要です");
        errorcnt = errorcnt + 1;
      } else {
        setErrorIsConsent("");
      }

      if (errorcnt > 0) {
        return console.log("エラーあり");
      }

      const contactList = [{
        productName: productName
        , countryName: countryName
        , contactDetail: contactDetail
        , companyName: companyName
        , corpoNum: corpoNum
        , director: director
        , nameKanji: nameKanji
        , nameKana: nameKana
        , mailAddress: mailAddress
        , phoneNumber: phoneNumber
        , noShare: noShare
        , isConsent: isConsent
      }];

      console.log(contactList);

      return navigate("/D0042ContactConfirm", { state: { dataList: contactList } });
    } catch (e) {
      console.log("例外が発生しました");
      console.log(e.message);
    }
  }

  // 住所自動入力ボタン処理
  // async function AddressSearch() {
  //   try {
  //     console.log("住所自動入力開始");

  //     if (!address1 || address1.length != 7) {
  //       console.log("住所自動入力終了（エラー）");
  //       return setErrorAddress1("郵便番号は7桁で入力してください。");
  //     } else {
  //       setErrorAddress1("ハイフン不要");
  //     }

  //     const res = await axios.get(
  //       "https://zipcloud.ibsnet.co.jp/api/search",
  //       {
  //         params: {
  //           zipcode: address1
  //         }
  //       }
  //     );

  //     if (res.data.status == 200 && res.data.results) {
  //       const result = res.data.results[0];
  //       setAddress2(result["address1"]);
  //       setAddress3(result["address2"]);
  //     } else {
  //       console.log("住所自動入力終了（エラー）");
  //       return setErrorAddress1("入力した郵便番号は存在しません。");
  //     }

  //     console.log("住所自動入力終了（正常）");
  //   } catch (e) {
  //     console.log("例外が発生しました");
  //     console.log(e.message);
  //   }
  // }


  return (
    <>
      <MenuMenu sel={0} />

      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg" style={{paddingLeft:"0", paddingRight:"0"}}>
                <Stack spacing={2}>

                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                  >
                    <Link underline="hover" key="1" color="inherit" href="./" style={{fontSize:"14px"}}>
                      TOP
                    </Link>,
                    <Typography key="2" color="text.primary" style={{fontSize:"14px"}}>
                      お問合せ
                    </Typography>
                  </Breadcrumbs>

                  <h1>お問合せ</h1>

                  <Stepper activeStep={0} alternativeLabel>
                    {steps.map((label) => (
                      <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>

                  <div style={{
                    backgroundColor: "#EDEEF2"
                    , padding: "20px 20px 20px 40px"
                    // , paddingLeft: "40px"
                  }}>
                    <ul style={{ listStyleType: "disc" }}>
                      <li>
                        当ホームページに関するご質問を受け付けています。
                        <br />
                        次の事項をお読みになり、必要事項を入力の上、「送信確認」ボタンを押してください。
                      </li>
                      <li>
                        ご質問については後日、土日祝日を除く開庁時間中に担当から回答します。また、回答に時間を要する場合がありますので、ご了承ください。<br />
                      </li>
                      <li>
                        個人情報の取り扱いについては、<Link href="./D011PrivacyPolicy" target="_blank">プライバシーポリシー</Link>をご覧ください。このページで入力された情報はSSLにより暗号化されて送信されます。<br />
                      </li>
                      <li>
                        環境依存文字(丸付き文字「①」・括弧付き文字「㈱」・ローマ数字「Ⅱ,Ⅳ」・単位記号「㎡」・全角マイナス「－」
                        など)の使用は、文字化けすることがあるためご遠慮ください。<br />
                      </li>
                      <li>
                        メールアドレスの入力間違いが大変多くなっています。送信前にもう一度お確かめください。確実な回答のために連絡先は複数入力いただくことを推奨します。<br />
                      </li>
                      <li>
                        メールでの回答を希望される方はドメイン【@maff.go.jp】を受信できるように設定してください。<br />
                      </li>
                    </ul>
                  </div>
                  <Divider />

                  <dl>
                    <dt>
                      輸出品目名
                    </dt>
                    <dd>
                      <TextField id="product_name" required
                        value={productName}
                        onChange={e => { setProductName(e.target.value) }}
                        style={{ width: '100%' }}
                      />
                    </dd>
                  </dl>
                  <Divider />

                  <dl>
                    <dt>
                      輸出先国名
                    </dt>
                    <dd>
                      <TextField id="country_name" required
                        value={countryName}
                        onChange={e => { setCountryName(e.target.value) }}
                        style={{ width: '100%' }}
                      />
                    </dd>
                  </dl>
                  <Divider />


                  <dl>
                    <dt>
                      相談内容※1000文字以内
                      <span class="hissu">必須</span>
                    </dt>
                    <dd>
                      <TextField id="contact_detail" required multiline
                        style={{ width: '100%' }}
                        inputProps={{ maxLength: 1000 }}
                        error={Boolean(errorContactDetail == "お問い合わせ内容を入力してください。" ? false : true)}
                        helperText={errorContactDetail}
                        rows={5}
                        value={contactDetail}
                        onChange={e => { setContactDetail(e.target.value) }}
                      />

                    </dd>
                  </dl>
                  <Divider />

                  <Stack spacing={2}
                    direction={{ xs: 'column', md: 'row' }}
                    // direction="row"
                    style={{ width: "100%" }}>
                    <dl style={{ width: "100%" }}>
                      <dt>企業名</dt>
                      <dd>
                        <TextField id="name_kana"
                          style={{ width: "100%" }}
                          helperText="例）株式会社農林"
                          value={companyName}
                          onChange={e => { setCompanyName(e.target.value) }} />
                      </dd>
                    </dl>
                    <dl style={{ marginTop: "0px", width: "100%" }}>
                      <dt>法人番号</dt>
                      <dd>
                        <TextField id="corpo_num"
                          style={{ width: "100%" }}
                          helperText="000000000000"
                          value={corpoNum}
                          onChange={e => { setCorpoNum(e.target.value) }} />
                      </dd>
                    </dl>
                  </Stack>
                  <Divider />
                  <dl style={{ width: "100%" }}>
                    <dt>役職</dt>
                    <dd>
                      <TextField id="director"
                        style={{ width: "100%" }}
                        helperText="例）株式会社農林"
                        value={director}
                        onChange={e => { setDirector(e.target.value) }} />
                    </dd>
                  </dl>
                  <Divider />

                  <dl>
                    <dt>氏名（漢字）
                      <span class="hissu">必須</span>
                    </dt>
                    <dd>
                      <TextField id="name" required
                        style={{ width: "100%" }}
                        error={Boolean(errorNameKanji == "例）農林　太郎" ? false : true)}
                        helperText={errorNameKanji}
                        value={nameKanji}
                        onChange={e => { setNameKanji(e.target.value) }}
                      />
                    </dd>
                  </dl>
                  <Divider />

                  <dl>
                    <dt>氏名（かな）
                      <span class="hissu">必須</span>
                    </dt>
                    <dd>
                      <TextField id="name_kana" required
                        style={{ width: "100%" }}
                        error={Boolean(errorNameKana == "例）のうりん　たろう" ? false : true)}
                        helperText={errorNameKana}
                        value={nameKana}
                        onChange={e => { setNameKana(e.target.value) }} />

                    </dd>
                  </dl>
                  <Divider />

                  <dl>
                    <dt>メールアドレス
                      <span class="hissu">必須</span>
                    </dt>
                    <dd>
                      <TextField id="name_kana" required type={"email"}
                        style={{ width: "100%" }}
                        error={Boolean(errorMailAddress == "例）nourin@example.co.jp" ? false : true)}
                        helperText={errorMailAddress}
                        value={mailAddress}
                        onChange={e => { setMailAddress(e.target.value) }}
                      />

                    </dd>
                  </dl>
                  <Divider />

                  <dl>
                    <dt>電話番号</dt>
                    <dd>
                      <TextField id="name_kana" type="tel"
                        style={{ width: "100%" }}
                        helperText="例）0312345678"
                        value={phoneNumber}
                        onChange={e => { setPhoneNumber(e.target.value) }} />

                    </dd>
                  </dl>
                  <Divider />

                  <dl>
                    <dt>相談内容の取扱いについて</dt>
                    <dd>
                      <div>
                        <div>本相談内容を輸出に関係する省庁やJETRO等の政府関係機関にて共有させていただくことができない場合は、
                          「共有を承諾しない」にチェックをいれてください。
                        </div>
                        <FormControl>
                          <FormControlLabel control={<Checkbox
                            checked={noShare}
                            onChange={e => { setNoShare(e.target.checked) }} />}
                            label="共有を承諾しない" />
                        </FormControl>
                      </div>

                    </dd>
                  </dl>
                  <Divider />

                  <dl>
                    <dt>個人情報の取扱いについて
                      <span class="hissu">必須</span>
                    </dt>
                    <dd>
                      <div>
                        <div>ご提供いただいた個人情報は、弊省の<Link href="./D011PrivacyPolicy" target="_blank">プライバシーポリシー</Link>に則ってお取り扱いいたします。
                          同意いただける方は「プライバシーポリシーに同意する」にチェックをいれて「入力内容確認」ボタンを押してください。</div>
                        <FormControl error={errorIsConsent}>
                          <FormControlLabel control={<Checkbox required
                            checked={isConsent}
                            onChange={e => { setIsConsent(e.target.checked) }} />}
                            label="プライバシーポリシーに同意する" />
                          <FormHelperText>{errorIsConsent}</FormHelperText>
                        </FormControl>
                      </div>
                    </dd>
                  </dl>
                  <Divider />

                  {/* <FormLabel id="demo-row-radio-buttons-group-label">住所</FormLabel>
                  <Stack spacing={2} direction="row">
                    <TextField id="name_kana" type={"number"} label="郵便番号"
                      helperText={errorAddress1}
                      error={Boolean(errorAddress1 == "ハイフン不要" ? false : true)}
                      style={{ width: '150px' }} value={address1}
                      onChange={e => { setAddress1(e.target.value) }}
                    />
                    <Button style={{ height: '56px', width: '150px', margin: '10px 0 10' }}
                      onClick={AddressSearch}>住所自動入力
                    </Button>
                    <Link style={{ height: '24px' }} href="//www.post.japanpost.jp/zipcode/"
                      target="_blank" rel="noopener">郵便番号がわからない方</Link>
                  </Stack> */}

                  {/* <Stack spacing={2} direction="row">

                    <TextField id="name_kana" label="都道府県"
                      style={{ width: '20%' }} value={address2}
                      onChange={e => { setAddress2(e.target.value) }} />
                    <TextField id="name_kana" label="市区町村名　番地・ビル名"
                      helperText="例）千代田区霞が関１－２－１" style={{ width: '80%' }}
                      value={address3}
                      onChange={e => { setAddress3(e.target.value) }}
                    />
                  </Stack>
                  <Divider /> */}

                  {/* <div>
                    <FormLabel id="demo-row-radio-buttons-group-label">性別</FormLabel>
                    <RadioGroup
                      row
                      name="row-radio-buttons-group"
                      value={sex}
                      onChange={(event) => {
                        setSex(event.target.value);
                      }}
                    >
                      <FormControlLabel value="男性" control={<Radio />} label="男性" />
                      <FormControlLabel value="女性" control={<Radio />} label="女性" />
                      <FormControlLabel value="その他" control={<Radio />} label="その他" />
                    </RadioGroup>
                  </div>
                  <Divider /> */}


                  {/* <FormControl variant="outlined" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-standard-label">年代</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={age}
                      label="年代"
                      sx={{ width: '130px' }}
                      onChange={(event) => {
                        setAge(event.target.value);
                      }}
                    >
                      <MenuItem value="10代">10代</MenuItem>
                      <MenuItem value="20代">20代</MenuItem>
                      <MenuItem value="30代">30代</MenuItem>
                      <MenuItem value="40代">40代</MenuItem>
                      <MenuItem value="50代">50代</MenuItem>
                      <MenuItem value="60代以上">60代以上</MenuItem>
                    </Select>
                    <FormHelperText>お選びください</FormHelperText>

                  </FormControl>
                  <Divider /> */}

                  {/* <div className="center">
                    <Button
                      style={{
                        width: '200px'
                        , borderRadius: "28px"
                      }}
                      sx={{ backgroundColor: "#B00002" }}
                      onClick={ContactCheck}>入力内容確認</Button>
                  </div> */}

                  <div
                    style={{
                      display: "flex"
                      , justifyContent: "center"
                      , position: "relative"
                      , flexWrap: "wrap"
                      , marginTop: "40px"
                      , marginBottom: "40px"
                    }}>
                    <input type="button"
                      class="decision_button"
                      value="入力内容確認"
                      onClick={ContactCheck} />
                  </div>

                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default D0041ContactTop;